var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"debugger-iframe",attrs:{"src":_vm.debuggerUrl,"frameborder":"0"}})
}
var staticRenderFns = []

export { render, staticRenderFns }